__turbopack_context__.v({
  "checkbox": "CredentialsToggle-module__ySwfVW__checkbox",
  "indicator": "CredentialsToggle-module__ySwfVW__indicator",
  "label": "CredentialsToggle-module__ySwfVW__label",
  "toggle": "CredentialsToggle-module__ySwfVW__toggle",
});
